// Lightweight cheerful sound effects using the Web Audio API (no asset files).
let ctx;
function ac() {
  if (typeof window === "undefined") return null;
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

function isMuted() {
  return localStorage.getItem("rfa_sfx_muted") === "1";
}
export function toggleMuted() {
  const next = isMuted() ? "0" : "1";
  localStorage.setItem("rfa_sfx_muted", next);
  return next === "1";
}
export function getMuted() {
  return isMuted();
}

function note(freq, start, dur, { type = "sine", gain = 0.14 } = {}) {
  const c = ac();
  if (!c) return;
  const t0 = c.currentTime + start;
  const osc = c.createOscillator();
  const g = c.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  g.gain.setValueAtTime(0, t0);
  g.gain.linearRampToValueAtTime(gain, t0 + 0.012);
  g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
  osc.connect(g).connect(c.destination);
  osc.start(t0);
  osc.stop(t0 + dur + 0.02);
}

// Bright two-note "ding" for correct answers.
export function playCorrect() {
  if (isMuted()) return;
  note(880, 0, 0.14, { type: "triangle" });
  note(1318.5, 0.09, 0.18, { type: "triangle" });
}

// Soft low "boop" for wrong answers.
export function playWrong() {
  if (isMuted()) return;
  note(196, 0, 0.22, { type: "sine", gain: 0.1 });
}

// Rising arpeggio for finishing / winning a game.
export function playWin() {
  if (isMuted()) return;
  [523.25, 659.25, 783.99, 1046.5].forEach((f, i) => note(f, i * 0.11, 0.22, { type: "triangle" }));
}

// Sparkly fanfare for a new badge unlock.
export function playBadge() {
  if (isMuted()) return;
  [659.25, 987.77, 1318.5].forEach((f, i) => note(f, i * 0.1, 0.26, { type: "triangle", gain: 0.16 }));
  note(1975.5, 0.3, 0.3, { type: "sine", gain: 0.1 });
}
